import { Box } from "@chakra-ui/react";

import { Helmet, HelmetProvider } from "react-helmet-async";
import Hero from "./Hero";
import Problem from "./Problem";
import Solution from "./Solution";
import Features from "./Features";
import HowItWorks from "./HowItWorks";
import ForYou from "./ForYou";
import SocialProof from "./SocialProof";
import CTABanner from "./CTABanner";

// ─── SEO Head ─────────────────────────────────────────────────────────────────
const structuredData = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Wobble",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  description:
    "Egyszerű és gyors online időpontfoglaló rendszer és weboldal egyéni- és kisvállalkozásoknak.",
  url: "https://wobble.hu",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "HUF",
    description: "30 napos ingyenes próbaidőszak",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    reviewCount: "2400",
  },
};

const SEOHead = () => (
  <Helmet>
    {/* Primary */}
    <html lang="hu" />
    <title>Wobble – Online időpontfoglaló szolgáltatóknak</title>
    <meta
      name="description"
      content="Egyszerű online időpontfoglaló rendszer és weboldal kisvállalkozásoknak. 30 napos ingyenes próba, kártyaadatok nélkül. Indulj el pillanatok alatt."
    />
    <meta
      name="keywords"
      content="időpontfoglaló, online foglalás, kisvállalkozás, szolgáltatók, pilates, edzés, sport, workshop, masszázs, lovas oktatás, weboldal, foglalási rendszer, egyéni vállalkozó"
    />
    <link rel="canonical" href="https://wobble.hu" />

    {/* Open Graph – Facebook / LinkedIn ads */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://wobble.hu" />
    <meta
      property="og:title"
      content="Wobble – Időpontfoglaló rendszer, online megjelenés"
    />
    <meta
      property="og:description"
      content="Foglalási rendszer szolgáltatóknak. Próbáld ki ingyen – nem kérünk kártyaadatokat."
    />
    <meta property="og:image" content="https://wobble.hu/assets/og-image.png" />
    <meta property="og:locale" content="hu_HU" />
    <meta property="og:site_name" content="Wobble" />

    {/* Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Wobble – Időpontfoglaló rendszer" />
    <meta
      name="twitter:description"
      content="Egyszerű online időpontfoglaló szolgáltatóknak. Kipróbálom ingyen!"
    />
    <meta
      name="twitter:image"
      content="https://wobble.hu/assets/og-image.png"
    />

    {/* Crawl hints */}
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Structured data (Schema.org) */}
    <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
  </Helmet>
);

const Landing = () => (
  <HelmetProvider>
    <SEOHead />
    <Box w="full" fontFamily="'DM Sans', sans-serif">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,700;12..96,800&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,300&display=swap');
        h1,h2,h3,h4 { font-family: 'Bricolage Grotesque', sans-serif !important; }
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
      `}</style>

      <Box as="main">
        <Hero />
        <Problem />
        <Solution />
        <Features />
        <HowItWorks />
        <ForYou />
        <SocialProof />
        <CTABanner />
      </Box>
    </Box>
  </HelmetProvider>
);

export default Landing;
